import React from "react";
import { apple, google } from "../assets";
import styles, { layout } from "../style";
import { motion } from "framer-motion";

const Billing = ({ scaleUpVariants }) => (
  <section id="product" className={layout.sectionReverse}>
    {/* reverse order on mobile */}
    <div className={layout.sectionImgReverse}>
      <motion.div
        className={`relative z-[5] sm:mr-8 mr-0 aspect-w-16 aspect-h-9 overflow-hidden rounded-lg shadow-lg border-2 border-gray-100`
          + ` sm:w-[560px] sm:h-[315px] w-full h-[56vw]`
        }
        variants={scaleUpVariants}
        initial={scaleUpVariants.hidden}
        whileInView={scaleUpVariants.whileInView}
        viewport={scaleUpVariants.viewport}
      >
        <iframe
          className="w-full h-full"
          src="https://www.youtube.com/embed/21jMa7UFzjw"
          title="JobMatch video para Proinnóvate"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen=""
        />
      </motion.div>
      {/* BACKGROUND GRADIENTS */}
      <div className="absolute z-[3] -left-1/2 top-0 w-[50%] h-[50%] rounded-full white__gradient"></div>
      <div className="absolute z-[0] -left-1/2 bottom-0 w-[50%] h-[50%] rounded-full pink__gradient"></div>
    </div>
    {/* HEADING */}
    <div className={layout.sectionInfo}>
      <h2 className={styles.heading2}>
        Vea como funciona <br className="hidden sm:block" />
        <span className="text-secondary">Job Match</span>
      </h2>
      <p className={`${styles.paragraph} max-w-[470px] mt-5`}>
        Mire este video para ver cómo Job Match puede ayudarlo a encontrar el trabajo de sus sueños.
      </p>
      <div className="flex flex-wrap mt-6 flow-row sm:mt-10">
        <img
          src={apple}
          alt="apple store"
          className="w-[128px] h-[42px] object-contain mr-5 cursor-pointer"
        />
        <img
          src={google}
          alt="google play"
          className="w-[128px] h-[42px] object-contain  cursor-pointer"
        />
      </div>
    </div>
  </section>
);

export default Billing;
